module.exports = __webpack_public_path__ + "img/consult_info2.40ccce10.png";